import React, {  } from 'react'
import { Badge } from '@rockr/rock-ui'
import { OfferInput } from '../../shared/types/skus'
import './Badge.css'


type Props = {
  offer: OfferInput
}

export const OfferTag: React.FC<Props> = ({
  offer
}) => {
  let color = '#225ED8'
  let text = 'In use'
  if (!offer.id) {
    color = '#F23F87'
    text = 'New'
  } else if(offer.id && offer.isUpdated) {
    color='#FFB92E'
    text = 'Updated'
  }
  return (
   <Badge variant='solid' bg={color}>{ text }</Badge>
  )
}
